import React, { useState, useEffect } from "react";
import axios from "axios";
import { HiSearch, HiPencil, HiTrash } from "react-icons/hi";
import { DeleteStaff } from "./components/DeleteStaff";
import CreateEditStaff from "./components/CreateEditStaff";
import PermissionViewModal from "../RolePermission/components/PermissionViewModal";
import { usePermission } from "Context/PermissionContext";
import Role from "../RolePermission/Role";
import StaffWalletDashboard from "./StaffWalletDashboard";

const StaffDashboard = () => {
  const [loading, setLoading] = useState(true);
  const [staffList, setStaffList] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [editData, setEditData] = useState(null);

  // Search + Pagination States
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [openPermissionModal, setOpenPermissionModal] = useState(false);
  const [selectedPermission, setSelectedPermission] = useState(null);
  const [activeTab, setActiveTab] = useState("staff");
  const { permissions } = usePermission();
  const currentTabPermissions = permissions?.staffManagement?.permissions;

  // Fetch Staff API
  const getAllStaff = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/staff/get-all-staff`,
        {
          params: { search, page, limit },
        }
      );

      if (res.data.success) {
        setStaffList(res.data.data);
        setTotalPages(res.data.pagination.totalPages);
      }
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  // Trigger API on search or page change
  // Trigger API on search or page change with Debouncing
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      getAllStaff();
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [search, page]);

  const refreshList = () => getAllStaff();

  return (
    <div className="mt-5 w-full">
      <div className="mb-4 flex border-b">
        <button
          className={`px-4 py-2 text-sm font-medium ${
            activeTab === "staff"
              ? "border-b-2 border-[#c51369] text-[#c51369]"
              : "text-gray-500"
          }`}
          onClick={() => setActiveTab("staff")}
        >
          Staffs
        </button>
        <button
          className={`px-4 py-2 text-sm font-medium ${
            activeTab === "role"
              ? "border-b-2 border-[#c51369] text-[#c51369]"
              : "text-gray-500"
          }`}
          onClick={() => setActiveTab("role")}
        >
          Roles
        </button>
        <button
          className={`px-4 py-2 text-sm font-medium ${
            activeTab === "wallet"
              ? "border-b-2 border-[#c51369] text-[#c51369]"
              : "text-gray-500"
          }`}
          onClick={() => setActiveTab("wallet")}
        >
          Wallet
        </button>
      </div>
      {activeTab === "staff" && (
        <>
          {" "}
          {/* SEARCH + ADD BUTTON */}
          <div className="flex flex-col items-center justify-between space-y-4 rounded-2xl bg-white p-5 shadow-sm md:flex-row md:space-y-0 ">
            {/* Search Box */}
            <div className="relative w-full md:w-1/2 ">
              <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-500">
                <HiSearch color="#c51369" className="h-5 w-5" />
              </span>

              <input
                type="text"
                placeholder="Search by name or phone..."
                className="block w-full rounded-md border border-gray-300 px-4 py-2 pl-10 text-gray-700 transition-all focus:border-[#c51369] focus:ring-1 focus:ring-[#c51369]"
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setPage(1);
                }}
              />
            </div>

            {/* Add Button */}
            {currentTabPermissions?.create && (
              <button
                className="rounded-full bg-[#c51369] p-3 px-4 py-2 text-white shadow"
                onClick={() => {
                  setEditData(null);
                  setOpenModal(true);
                }}
              >
                + Create Staff
              </button>
            )}
          </div>
          {/* TABLE SECTION */}
          <div className="mt-6 overflow-x-auto rounded-xl shadow-sm">
            <table className="w-full rounded-t-2xl text-left text-sm">
              <thead className="text-md bg-[#e0ced7] text-center uppercase tracking-wide text-navy-900">
                <tr>
                  <th className="px-6 py-3">Sl No.</th>
                  <th className="px-6 py-3">Created</th>
                  <th className="px-6 py-3">Full Name</th>
                  <th className="px-6 py-3">Role</th>
                  <th className="px-6 py-3">Gender</th>
                  <th className="px-6 py-3 text-center">Action</th>
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  [...Array(5)].map((_, i) => (
                    <tr key={i} className="animate-pulse bg-white ">
                      <td className="border px-6 py-4 text-center">
                        <div className="h-4 w-6 rounded bg-gray-200"></div>
                      </td>
                      <td className="border px-6 py-4 text-center">
                        <div className="h-4 w-32 rounded bg-gray-200"></div>
                      </td>

                      <td className="border px-6 py-4 text-center">
                        <div className="h-4 w-28 rounded bg-gray-200"></div>
                      </td>
                      <td className="border px-6 py-4 text-center">
                        <div className="h-4 w-24 rounded bg-gray-200"></div>
                      </td>
                      <td className="border px-6 py-4 text-center">
                        <div className="h-4 w-20 rounded bg-gray-200"></div>
                      </td>
                      <td className="border px-6 py-4 text-center">
                        <div className="mx-auto h-4 w-16 rounded bg-gray-200"></div>
                      </td>
                    </tr>
                  ))
                ) : staffList.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="py-4 text-center text-gray-500">
                      No staff found
                    </td>
                  </tr>
                ) : (
                  staffList.map((row, index) => (
                    <tr
                      key={row._id}
                      className="text-md group bg-white text-center tracking-wide"
                    >
                      <td className="border px-6 py-4">
                        {(page - 1) * limit + index + 1}
                      </td>

                      <td className="border px-6 py-4">
                        <div className="flex flex-col leading-tight">
                          <span className="font-semibold text-navy-700 ">
                            {new Date(row.createdAt).toLocaleDateString(
                              "en-IN"
                            )}
                          </span>

                          <span className="text-sm text-gray-600 ">
                            {new Date(row.createdAt).toLocaleTimeString(
                              "en-IN",
                              {
                                hour: "2-digit",
                                minute: "2-digit",
                              }
                            )}
                          </span>
                        </div>
                      </td>

                      {/* Full Name + Avatar */}
                      <td className="flex items-center border px-6 py-4">
                        <img
                          src="https://cdn-icons-png.flaticon.com/512/149/149071.png"
                          alt="avatar"
                          className="h-10 w-10 rounded-full"
                        />

                        <span className="ml-4">
                          <span className="font-bold capitalize text-navy-700 ">
                            {row.fullName}
                          </span>
                          <br />
                          <span className="text-gray-500 ">
                            {row.phoneNumber}
                          </span>
                        </span>
                      </td>

                      <td className="border px-6 py-4 capitalize">
                        {row?.rolePermission ? (
                          <button
                            onClick={() => {
                              setSelectedPermission(
                                row.rolePermission.permission
                              );
                              setOpenPermissionModal(true);
                            }}
                            className="text-[#c51369] underline hover:text-[#a81058]"
                          >
                            {row.rolePermission.rolename}
                          </button>
                        ) : (
                          "N/A"
                        )}
                      </td>

                      <td className="border px-6 py-4 capitalize">
                        {row.gender}
                      </td>

                      <td className="border px-6 py-4 text-center">
                        <div className="flex items-center justify-center gap-3">
                          {currentTabPermissions?.edit && (
                            <button
                              className="rounded-md bg-blue-100 p-2 text-[#c51369]"
                              onClick={() => {
                                setEditData(row);
                                setOpenModal(true);
                              }}
                            >
                              <HiPencil size={18} />
                            </button>
                          )}

                          {currentTabPermissions?.delete && (
                            <button
                              className="rounded-md bg-red-100 p-2 text-red-600 hover:bg-red-200"
                              onClick={() =>
                                DeleteStaff(row._id, () => refreshList())
                              }
                            >
                              <HiTrash size={18} />
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </>
      )}

      {activeTab === "role" && <Role />}

      {activeTab === "wallet" && <StaffWalletDashboard />}

      {/* CREATE/EDIT MODAL */}
      <CreateEditStaff
        open={openModal}
        onClose={() => setOpenModal(false)}
        editData={editData}
        refreshList={refreshList}
      />
      <PermissionViewModal
        open={openPermissionModal}
        onClose={() => setOpenPermissionModal(false)}
        permission={selectedPermission}
      />
    </div>
  );
};

export default StaffDashboard;
